// extracted by mini-css-extract-plugin
export default {"badge":"EgUq","start-icon":"vE6u","startIcon":"vE6u","end-icon":"isfo","endIcon":"isfo","error":"LM3x","success":"vZpL","warning":"cYv9","info":"N4ny"};